import { Splide, SplideSlide } from "@splidejs/react-splide";
import "@splidejs/react-splide/css";

const Slider = ({
  options = {},
  className = "",
  children
}) => {
  const defaultOptions = {
    type: "loop",
    perPage: 1,
    autoplay: true,
    interval: 4000,
    pauseOnHover: true,
    arrows: true,
    pagination: true,
    gap: "1rem",
    ...options,
  };

  return (
    <Splide options={defaultOptions} className={className}>
      {children({ SplideSlide })}
    </Splide>
  );
};

export default Slider;
